export default "assets/images/marker-373264b3.svg";